<div>
  <div class="checkbox-with-star">
    <oui-checkbox [label]="objectifReferentiel.libelle" [control]="control" [errors]="errortexts"> </oui-checkbox>

    <span *ngIf="isInRequiredGroup" class="mandatory-star"> * </span>
  </div>

  @if (showIncompatibleError()) {
  <div class="oui-error ng-star-inserted margin-left-32">
    {{ customIncomatibleErrorMessage }}
  </div>
  }
</div>
